import {
  faCog, faFileImage, faIdCard, faPencil, faStore, faToggleOn,
} from '@fortawesome/pro-light-svg-icons'

import { generateUrls } from '@hooks/useBrand'

import type { BrandModel } from '@models/types'

interface GenerateTabBarItemsProps {
  brand: Partial<BrandModel>,
  brandSettingsEnabled: boolean,
  isBrandUser: boolean,
}

const generateTabBarItems = (props: GenerateTabBarItemsProps) => {
  const { brand, brandSettingsEnabled, isBrandUser } = props

  const urls = generateUrls(brand)
  const {
    editBrandCustomFieldsUrl,
    editBrandImageSettingsUrl,
    editBrandRelationsUrl,
    editBrandSettingsUrl,
    editBrandUrl,
    viewBrandAgenciesOverviewUrl,
  } = urls

  if (isBrandUser){
    return [
      {
        icon: faIdCard,
        href: editBrandUrl,
        key: 'details',
        title: brand?.title || 'Brand Details',
      },
      {
        icon: faToggleOn,
        href: editBrandRelationsUrl,
        key: 'relations',
        title: 'Relations',
      },
      {
        icon: faCog,
        href: editBrandSettingsUrl,
        key: 'settings',
        title: 'Brand Settings',
        hidden: !brandSettingsEnabled,
      },
      {
        icon: faFileImage,
        href: editBrandImageSettingsUrl,
        key: 'image-settings',
        title: 'Image Settings',
      },
      {
        icon: faPencil,
        href: editBrandCustomFieldsUrl,
        key: 'customFields',
        title: 'Custom Fields',
      },
      {
        icon: faStore,
        href: viewBrandAgenciesOverviewUrl,
        key: 'agenciesOverview',
        title: 'Agencies Overview',
      },
    ]
  }

  return [
    {
      icon: faIdCard,
      href: editBrandUrl,
      key: 'details',
      title: brand?.title || 'Brand Details',
    },
    {
      icon: faToggleOn,
      href: editBrandRelationsUrl,
      key: 'relations',
      title: 'Relations',
    },
    {
      icon: faCog,
      href: editBrandSettingsUrl,
      key: 'settings',
      title: 'Brand Settings',
      hidden: !brandSettingsEnabled,
    },
    {
      icon: faPencil,
      href: editBrandCustomFieldsUrl,
      key: 'customFields',
      title: 'Custom Fields',
    },
    {
      icon: faStore,
      href: viewBrandAgenciesOverviewUrl,
      key: 'agenciesOverview',
      title: 'Agencies Overview',
    },
  ]
}

export default generateTabBarItems
